import { Link } from 'react-router-dom';
import { ShoppingCart, Menu, X } from 'lucide-react';
import { useState, useEffect } from 'react';

const Navbar = () => {
  const [cartCount, setCartCount] = useState(0);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    updateCartCount();
    window.addEventListener('cartUpdated', updateCartCount);
    return () => window.removeEventListener('cartUpdated', updateCartCount);
  }, []);

  const updateCartCount = () => {
    const cart = JSON.parse(localStorage.getItem('avex_cart') || '[]');
    const total = cart.reduce((sum, item) => sum + item.quantity, 0);
    setCartCount(total);
  };

  return (
    <nav className="sticky top-0 z-50 bg-white border-b border-[#E5E5E5]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center" data-testid="nav-logo">
            <img
  src="/assets/avex-logo.png"
  alt="Avex Enterprises"
  className="h-12"
/>

          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <Link to="/" className="text-[#1A1A1A] hover:text-[#BFA15F] font-medium transition-colors" data-testid="nav-home">
              Home
            </Link>
            <Link to="/products" className="text-[#1A1A1A] hover:text-[#BFA15F] font-medium transition-colors" data-testid="nav-products">
              Products
            </Link>
            <Link to="/about" className="text-[#1A1A1A] hover:text-[#BFA15F] font-medium transition-colors" data-testid="nav-about">
              About
            </Link>
            <Link to="/contact" className="text-[#1A1A1A] hover:text-[#BFA15F] font-medium transition-colors" data-testid="nav-contact">
              Contact
            </Link>
            <Link to="/cart" className="relative" data-testid="nav-cart">
              <ShoppingCart className="h-6 w-6 text-[#1A1A1A] hover:text-[#BFA15F] transition-colors" />
              {cartCount > 0 && (
                <span className="absolute -top-2 -right-2 bg-[#BFA15F] text-white text-xs rounded-full h-5 w-5 flex items-center justify-center" data-testid="cart-count">
                  {cartCount}
                </span>
              )}
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden p-2"
            data-testid="mobile-menu-button"
          >
            {mobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden border-t border-[#E5E5E5] bg-white" data-testid="mobile-menu">
          <div className="px-4 py-4 space-y-3">
            <Link to="/" className="block py-2 text-[#1A1A1A] hover:text-[#BFA15F] font-medium" onClick={() => setMobileMenuOpen(false)}>
              Home
            </Link>
            <Link to="/products" className="block py-2 text-[#1A1A1A] hover:text-[#BFA15F] font-medium" onClick={() => setMobileMenuOpen(false)}>
              Products
            </Link>
            <Link to="/about" className="block py-2 text-[#1A1A1A] hover:text-[#BFA15F] font-medium" onClick={() => setMobileMenuOpen(false)}>
              About
            </Link>
            <Link to="/contact" className="block py-2 text-[#1A1A1A] hover:text-[#BFA15F] font-medium" onClick={() => setMobileMenuOpen(false)}>
              Contact
            </Link>
            <Link to="/cart" className="flex items-center py-2 text-[#1A1A1A] hover:text-[#BFA15F] font-medium" onClick={() => setMobileMenuOpen(false)}>
              Cart {cartCount > 0 && <span className="ml-2 bg-[#BFA15F] text-white px-2 py-1 rounded-full text-xs">{cartCount}</span>}
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;